
let popup;
let popupInterval;

function showOauthDialog(url, callbackFn) {
    window.location.href = url;
    // if (!callbackFn) {
    //     window.location.href = url;
    // } else {
    //     var settings = '';
    //     var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : 0;
    //     var dualScreenTop = window.screenTop !== undefined ? window.screenTop : 0;
    //     var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : 500;
    //     var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : 500;
    //     var left = ((width / 2) - 500) + dualScreenLeft;
    //     var top = ((height / 2) - 500) + dualScreenTop;
    //     popup = window.open(url, '', settings + 'top=' + top + ',left=' + left + ',width=' + width + ',height=' + height);
    //     popupInterval = setInterval(function () {
    //         try {
    //             if (popup && popup.closed) {
    //                 clearInterval(popupInterval);
    //                 callbackFn();
    //             }
    //         } catch (e) {
    //             console.error(e);
    //         }
    //     }, 1000);
    // }
}

export default showOauthDialog;
